(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[710],{

/***/ 78348:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/integrations",
      function () {
        return __webpack_require__(56351);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 10305:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "KU": function() { return /* binding */ IntegrationsHeroGlobeIcon; },
/* harmony export */   "Wm": function() { return /* binding */ IntegrationsHeroShieldIcon; },
/* harmony export */   "YH": function() { return /* binding */ IntegrationsHeroBoltIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var IntegrationsHeroGlobeIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: 18,
        height: 18,
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": true,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M1.5 9H16.5",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M9 1.5C10.876 3.55335 11.9422 6.22745 12 9C11.9422 11.7725 10.876 14.4467 9 16.5C7.12404 14.4467 6.0578 11.7725 6 9C6.0578 6.22745 7.12404 3.55335 9 1.5V1.5Z",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
var IntegrationsHeroShieldIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: 18,
        height: 18,
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M8.25 15.5175C8.58152 15.3581 9.41848 15.3581 9.75 15.5175C10.8172 15.9822 14.25 13.0575 14.25 11.8125V4.5C14.25 4.08579 13.9142 3.75 13.5 3.75H4.5C4.08579 3.75 3.75 4.08579 3.75 4.5V11.8125C3.75 13.0575 7.18281 15.9822 8.25 15.5175Z",
            stroke: "currentColor",
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
var IntegrationsHeroBoltIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: 18,
        height: 18,
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M9.75 1.5L3.75 10.125H9L8.25 16.5L14.25 7.875H9L9.75 1.5Z",
            stroke: "currentColor",
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};


/***/ }),

/***/ 34148:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "H": function() { return /* reexport */ IntegrationsMatchCtaBlock; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./src/constants/sections.ts
var sections = __webpack_require__(6872);
// EXTERNAL MODULE: ./src/components/icons/ChevronForwardV4Icon.tsx
var ChevronForwardV4Icon = __webpack_require__(18805);
// EXTERNAL MODULE: ./src/components/landingV4/common/ButtonLink/index.ts + 1 modules
var ButtonLink = __webpack_require__(64791);
// EXTERNAL MODULE: ./src/components/landingV4/common/Container/index.ts + 1 modules
var Container = __webpack_require__(67306);
// EXTERNAL MODULE: ./src/components/landingV4/common/Flex/index.ts + 1 modules
var Flex = __webpack_require__(75487);
// EXTERNAL MODULE: ./src/components/landingV4/common/Text/index.ts + 1 modules
var Text = __webpack_require__(50576);
// EXTERNAL MODULE: ./src/components/landingV4/IntegrationsHero/IntegrationsHeroIcons.tsx
var IntegrationsHeroIcons = __webpack_require__(10305);
// EXTERNAL MODULE: ./src/components/landingV4/IntegrationsMatchCtaBlock/IntegrationsMatchCtaBlock.module.scss
var IntegrationsMatchCtaBlock_module = __webpack_require__(81793);
var IntegrationsMatchCtaBlock_module_default = /*#__PURE__*/__webpack_require__.n(IntegrationsMatchCtaBlock_module);
;// CONCATENATED MODULE: ./src/components/landingV4/IntegrationsMatchCtaBlock/IntegrationsMatchCtaBlock.tsx










var DocsExternalArrowIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: 16,
        height: 16,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.83333 2.83337H13.1667V10.1667",
                stroke: "currentColor",
                strokeWidth: 1.33,
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M2.83337 13.1667V9.61115C2.83337 8.98648 3.06937 8.38737 3.48615 7.94337L13.1667 2.83337",
                stroke: "currentColor",
                strokeWidth: 1.33,
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.83337 2.83337H13.1667V6.1667",
                stroke: "currentColor",
                strokeWidth: 1.33,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
var DEFAULT_MATCH_HEADLINE = "Didn't find the perfect match?";
var DEFAULT_MATCH_DESCRIPTION = "Our integration library is constantly expanding. Contact us, and we'll customize a solution tailored to your specific business needs.";
var DEFAULT_VISUAL_CAPTION = "100+ integrations worldwide";
var DEFAULT_ASIDE_CAPTION_ID = "integrations-cta-globe-caption";
var IntegrationsMatchCtaBlock = function(param) {
    var _headline = param.headline, headline = _headline === void 0 ? DEFAULT_MATCH_HEADLINE : _headline, _description = param.description, description = _description === void 0 ? DEFAULT_MATCH_DESCRIPTION : _description, _visualCaption = param.visualCaption, visualCaption = _visualCaption === void 0 ? DEFAULT_VISUAL_CAPTION : _visualCaption, _asideCaptionId = param.asideCaptionId, asideCaptionId = _asideCaptionId === void 0 ? DEFAULT_ASIDE_CAPTION_ID : _asideCaptionId;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
        className: (IntegrationsMatchCtaBlock_module_default()).root,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (IntegrationsMatchCtaBlock_module_default()).banner,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (IntegrationsMatchCtaBlock_module_default()).copy,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                            type: "h2",
                            className: (IntegrationsMatchCtaBlock_module_default()).headline,
                            children: headline
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                            type: "regular16",
                            color: "white50",
                            whiteSpace: "normal",
                            className: (IntegrationsMatchCtaBlock_module_default()).description,
                            children: description
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                            className: (IntegrationsMatchCtaBlock_module_default()).actions,
                            gap: 12,
                            wrap: "wrap",
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLink/* ButtonLink */.Z, {
                                    href: "#".concat(sections/* SECTIONS_IDS.contact */.s.contact),
                                    variant: "primary",
                                    iconRight: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronForwardV4Icon/* ChevronForwardV4Icon */.E, {}),
                                    className: (0,clsx_m/* default */.Z)((IntegrationsMatchCtaBlock_module_default()).contactLinkPlain, (IntegrationsMatchCtaBlock_module_default()).contactSalesButton),
                                    children: "Contact Sales"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLink/* ButtonLink */.Z, {
                                    href: "/docs",
                                    isOutsideLink: true,
                                    variant: "primary",
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    iconRight: /*#__PURE__*/ (0,jsx_runtime.jsx)(DocsExternalArrowIcon, {}),
                                    className: (0,clsx_m/* default */.Z)((IntegrationsMatchCtaBlock_module_default()).contactLinkPlain, (IntegrationsMatchCtaBlock_module_default()).docsLinkButton),
                                    children: "API Documentation"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("aside", {
                    className: (IntegrationsMatchCtaBlock_module_default()).visual,
                    "aria-labelledby": asideCaptionId,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (IntegrationsMatchCtaBlock_module_default()).globeStage,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (IntegrationsMatchCtaBlock_module_default()).globeGlow,
                                    "aria-hidden": true
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (IntegrationsMatchCtaBlock_module_default()).globeCircle,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (IntegrationsMatchCtaBlock_module_default()).globeIcon,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IntegrationsHeroIcons/* IntegrationsHeroGlobeIcon */.KU, {})
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                            id: asideCaptionId,
                            type: "regular14",
                            align: "center",
                            whiteSpace: "normal",
                            className: (IntegrationsMatchCtaBlock_module_default()).globeSubtext,
                            children: visualCaption
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/landingV4/IntegrationsMatchCtaBlock/index.ts



/***/ }),

/***/ 10461:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C$": function() { return /* binding */ MethodSpecsH2HIcon; },
/* harmony export */   "T3": function() { return /* binding */ MethodSpecsWalletIcon; },
/* harmony export */   "ZL": function() { return /* binding */ MethodSpecsBookIcon; },
/* harmony export */   "cN": function() { return /* binding */ MethodSpecsGatewayCardIcon; },
/* harmony export */   "p4": function() { return /* binding */ MethodSpecsP2PIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

/** Open book — section title only. */ var MethodSpecsBookIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": true,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M10 5.8335V17.5002",
                stroke: "currentColor",
                strokeWidth: "1.66667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M2.49996 15C2.03972 15 1.66663 14.6269 1.66663 14.1667V3.33333C1.66663 2.8731 2.03972 2.5 2.49996 2.5H6.66663C8.50758 2.5 9.99996 3.99238 9.99996 5.83333C9.99996 3.99238 11.4923 2.5 13.3333 2.5H17.5C17.9602 2.5 18.3333 2.8731 18.3333 3.33333V14.1667C18.3333 14.6269 17.9602 15 17.5 15H12.5C11.1192 15 9.99996 16.1193 9.99996 17.5C9.99996 16.1193 8.88067 15 7.49996 15H2.49996",
                stroke: "currentColor",
                strokeWidth: "1.66667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
/** Card (Gateway) — payment card outline. */ var MethodSpecsGatewayCardIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": true,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M3.33329 4.1665H16.6666C17.5871 4.1665 18.3333 4.9127 18.3333 5.83317V14.1665C18.3333 15.087 17.5871 15.8332 16.6666 15.8332H3.33329C2.41282 15.8332 1.66663 15.087 1.66663 14.1665V5.83317C1.66663 4.9127 2.41282 4.1665 3.33329 4.1665V4.1665",
                stroke: "currentColor",
                strokeWidth: "1.66667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M1.66663 8.3335H18.3333",
                stroke: "currentColor",
                strokeWidth: "1.66667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
/** Card H2H — stacked blocks. */ var MethodSpecsH2HIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": true,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M3.33329 1.6665H16.6666C17.5871 1.6665 18.3333 2.4127 18.3333 3.33317V6.6665C18.3333 7.58698 17.5871 8.33317 16.6666 8.33317H3.33329C2.41282 8.33317 1.66663 7.58698 1.66663 6.6665V3.33317C1.66663 2.4127 2.41282 1.6665 3.33329 1.6665V1.6665",
                stroke: "currentColor",
                strokeWidth: "1.66667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M3.33329 11.6665H16.6666C17.5871 11.6665 18.3333 12.4127 18.3333 13.3332V16.6665C18.3333 17.587 17.5871 18.3332 16.6666 18.3332H3.33329C2.41282 18.3332 1.66663 17.587 1.66663 16.6665V13.3332C1.66663 12.4127 2.41282 11.6665 3.33329 11.6665V11.6665",
                stroke: "currentColor",
                strokeWidth: "1.66667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M5 5H5.00833",
                stroke: "currentColor",
                strokeWidth: "1.66667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M5 15H5.00833",
                stroke: "currentColor",
                strokeWidth: "1.66667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
/** P2P — people. */ var MethodSpecsP2PIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": true,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M13.3334 17.5V15.8333C13.3334 13.9924 11.841 12.5 10 12.5H5.00002C3.15907 12.5 1.66669 13.9924 1.66669 15.8333V17.5",
                stroke: "currentColor",
                strokeWidth: "1.66667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M13.3333 2.60645C14.8035 2.98758 15.8301 4.31434 15.8301 5.83311C15.8301 7.35189 14.8035 8.67864 13.3333 9.05978",
                stroke: "currentColor",
                strokeWidth: "1.66667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M18.3333 17.5001V15.8334C18.3322 14.3143 17.3041 12.9882 15.8333 12.6084",
                stroke: "currentColor",
                strokeWidth: "1.66667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M4.16669 5.83333C4.16669 7.67305 5.6603 9.16667 7.50002 9.16667C9.33974 9.16667 10.8334 7.67305 10.8334 5.83333C10.8334 3.99362 9.33974 2.5 7.50002 2.5C5.6603 2.5 4.16669 3.99362 4.16669 5.83333V5.83333",
                stroke: "currentColor",
                strokeWidth: "1.66667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
/** APM — wallet. */ var MethodSpecsWalletIcon = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": true,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M15.8333 5.83333V3.33333C15.8333 2.8731 15.4602 2.5 15 2.5H4.16667C3.24681 2.5 2.5 3.24681 2.5 4.16667C2.5 5.08652 3.24681 5.83333 4.16667 5.83333H16.6667C17.1269 5.83333 17.5 6.20643 17.5 6.66667V10H15C14.0801 10 13.3333 10.7468 13.3333 11.6667C13.3333 12.5865 14.0801 13.3333 15 13.3333H17.5C17.9602 13.3333 18.3333 12.9602 18.3333 12.5V10.8333C18.3333 10.3731 17.9602 10 17.5 10",
                stroke: "currentColor",
                strokeWidth: "1.66667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M2.5 4.1665V15.8332C2.5 16.7536 3.24619 17.4998 4.16667 17.4998H16.6667C17.1269 17.4998 17.5 17.1267 17.5 16.6665V13.3332",
                stroke: "currentColor",
                strokeWidth: "1.66667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};


/***/ }),

/***/ 56351:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ integrations; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/landingV4/FAQBlock/index.ts + 1 modules
var FAQBlock = __webpack_require__(51580);
// EXTERNAL MODULE: ./src/components/landingV4/FeedbackBlock/index.ts + 27 modules
var FeedbackBlock = __webpack_require__(52898);
// EXTERNAL MODULE: ./src/components/landingV4/Footer/index.ts + 1 modules
var Footer = __webpack_require__(60830);
// EXTERNAL MODULE: ./src/components/landingV4/Header/index.ts + 8 modules
var Header = __webpack_require__(13906);
// EXTERNAL MODULE: ./src/components/landingV4/common/Container/index.ts + 1 modules
var Container = __webpack_require__(67306);
// EXTERNAL MODULE: ./src/components/landingV4/common/Flex/index.ts + 1 modules
var Flex = __webpack_require__(75487);
// EXTERNAL MODULE: ./src/components/landingV4/common/Text/index.ts + 1 modules
var Text = __webpack_require__(50576);
// EXTERNAL MODULE: ./src/components/landingV4/IntegrationsHero/IntegrationsHero.module.scss
var IntegrationsHero_module = __webpack_require__(39095);
var IntegrationsHero_module_default = /*#__PURE__*/__webpack_require__.n(IntegrationsHero_module);
// EXTERNAL MODULE: ./src/components/landingV4/IntegrationsHero/IntegrationsHeroIcons.tsx
var IntegrationsHeroIcons = __webpack_require__(10305);
;// CONCATENATED MODULE: ./src/components/landingV4/IntegrationsHero/IntegrationsHero.tsx






function Badge(props) {
    var icon = props.icon, label = props.label;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
        className: (IntegrationsHero_module_default()).badge,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (IntegrationsHero_module_default()).badgeIcon,
                "aria-hidden": true,
                children: icon
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                type: "regular14",
                whiteSpace: "normal",
                children: label
            })
        ]
    });
}
var IntegrationsHero = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
        className: (IntegrationsHero_module_default()).root,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (IntegrationsHero_module_default()).inner,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                direction: "column",
                alignItems: "flexStart",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (IntegrationsHero_module_default()).sectionLabel,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (IntegrationsHero_module_default()).sectionLabelLine,
                                "aria-hidden": true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                type: "medium14",
                                color: "green",
                                className: (IntegrationsHero_module_default()).sectionEyebrow,
                                children: "Integrations"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                        type: "regular48",
                        color: "white",
                        className: (IntegrationsHero_module_default()).title,
                        children: "Ready-to-Use Integration Solutions"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                        type: "regular16",
                        color: "white50",
                        whiteSpace: "normal",
                        className: (IntegrationsHero_module_default()).description,
                        children: "Find the perfect payment configuration for your region and business model. SmartGates supports over 100+ integration scenarios for global pay-ins and mass pay-outs."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* Flex */.k, {
                        className: (IntegrationsHero_module_default()).badges,
                        gap: 12,
                        wrap: "wrap",
                        alignItems: "center",
                        childMinSize: "unset",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge, {
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(IntegrationsHeroIcons/* IntegrationsHeroGlobeIcon */.KU, {}),
                                label: "100+ Scenarios"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge, {
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(IntegrationsHeroIcons/* IntegrationsHeroShieldIcon */.Wm, {}),
                                label: "PCI DSS Compliant"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge, {
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(IntegrationsHeroIcons/* IntegrationsHeroBoltIcon */.YH, {}),
                                label: "Instant Setup"
                            })
                        ]
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/landingV4/IntegrationsHero/index.ts


// EXTERNAL MODULE: ./src/components/landingV4/IntegrationsMatchCtaBlock/index.ts + 1 modules
var IntegrationsMatchCtaBlock = __webpack_require__(34148);
// EXTERNAL MODULE: ./src/components/landingV4/IntegrationsMethodSpecsBlock/IntegrationsMethodSpecsBlock.module.scss
var IntegrationsMethodSpecsBlock_module = __webpack_require__(14633);
var IntegrationsMethodSpecsBlock_module_default = /*#__PURE__*/__webpack_require__.n(IntegrationsMethodSpecsBlock_module);
// EXTERNAL MODULE: ./src/components/landingV4/IntegrationsMethodSpecsBlock/MethodSpecsIcons.tsx
var MethodSpecsIcons = __webpack_require__(10461);
;// CONCATENATED MODULE: ./src/components/landingV4/IntegrationsMethodSpecsBlock/IntegrationsMethodSpecsBlock.tsx





var METHOD_SPECS = [
    {
        id: "gateway",
        title: "Card (Gateway)",
        description: "Standard integration via our secure payment widget. Minimal setup time, maximum security.",
        Icon: MethodSpecsIcons/* MethodSpecsGatewayCardIcon */.cN
    },
    {
        id: "h2h",
        title: "Card H2H",
        description: "For businesses that require a fully customized checkout experience on their own side (PCI DSS compliance required).",
        Icon: MethodSpecsIcons/* MethodSpecsH2HIcon */.C$
    },
    {
        id: "p2p",
        title: "P2P",
        description: "Person-to-person transfers optimized for high-speed processing and stability in emerging markets.",
        Icon: MethodSpecsIcons/* MethodSpecsP2PIcon */.p4
    },
    {
        id: "apm",
        title: "APM",
        description: "Local wallets, mobile payments, and bank transfers — essential for capturing local market share.",
        Icon: MethodSpecsIcons/* MethodSpecsWalletIcon */.T3
    }, 
];
var IntegrationsMethodSpecsBlock = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
        className: (IntegrationsMethodSpecsBlock_module_default()).root,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (IntegrationsMethodSpecsBlock_module_default()).sectionHead,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (IntegrationsMethodSpecsBlock_module_default()).sectionIcon,
                        "aria-hidden": true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MethodSpecsIcons/* MethodSpecsBookIcon */.ZL, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: (IntegrationsMethodSpecsBlock_module_default()).sectionTitle,
                        children: "Method Specifications"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (IntegrationsMethodSpecsBlock_module_default()).cards,
                children: METHOD_SPECS.map(function(param) {
                    var id = param.id, title = param.title, description = param.description, Icon = param.Icon;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                        className: (IntegrationsMethodSpecsBlock_module_default()).card,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (IntegrationsMethodSpecsBlock_module_default()).cardIconWrap,
                                "aria-hidden": true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                type: "h3",
                                color: "white",
                                className: (IntegrationsMethodSpecsBlock_module_default()).cardTitle,
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                type: "regular14",
                                color: "white50",
                                whiteSpace: "normal",
                                className: (IntegrationsMethodSpecsBlock_module_default()).cardDescription,
                                children: description
                            })
                        ]
                    }, id);
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/landingV4/IntegrationsMethodSpecsBlock/index.ts


;// CONCATENATED MODULE: ./src/components/landingV4/IntegrationsScenariosBlock/integrationScenarioHelpers.ts
var FILTER_EMPTY = "";
var FILTER_NOT_SELECTED_LABEL = "Not selected";
var TRANSACTION_LABELS = {
    "pay-in": "Pay-in",
    "pay-out": "Pay-out"
};
function formatMethod(method) {
    return method === "apm" ? "APM" : "Card";
}
/** Omits generic "Card" tag when the scenario method is already card. */ function getPaymentSystemTags(scenario) {
    var tags = scenario.tags, method = scenario.method;
    return tags.filter(function(t) {
        return !(method === "card" && t.toLowerCase() === "card");
    });
}

;// CONCATENATED MODULE: ./src/components/landingV4/IntegrationsScenariosBlock/integrationScenariosData.ts
/** Source: integrations spreadsheet (landing content). */ var INTEGRATION_SCENARIOS = [
    {
        id: "sbp-pay-in",
        transactionType: "pay-in",
        title: "SBP pay in",
        description: "Enable your customers to pay the way they prefer. Skip the card details: payments are completed instantly via QR code or a direct link. Optimized for mobile traffic and physical retail locations.",
        method: "card",
        geo: "RUS",
        currencies: [
            "RUB"
        ],
        tags: [],
        icon: "card"
    },
    {
        id: "morocco-pay-in",
        transactionType: "pay-in",
        title: "Morocco pay-in",
        description: "Integrate the leading alternative payment method in Morocco. With our API, you get a frictionless checkout process designed to drive maximum mobile conversions.",
        method: "card",
        geo: "Morocco",
        currencies: [
            "MAD"
        ],
        tags: [],
        icon: "card"
    },
    {
        id: "morocco-pay-out",
        transactionType: "pay-out",
        title: "Morocco pay-out",
        description: "Scale your operations in North Africa with Morocco’s leading financial network.",
        method: "apm",
        geo: "Morocco",
        currencies: [
            "MAD"
        ],
        tags: [],
        icon: "globe"
    },
    {
        id: "eur-ecom",
        transactionType: "pay-in",
        title: "EUR e-com",
        description: "Expand your reach across Europe and beyond with our comprehensive EUR acquiring solution. Provide your customers with a localized checkout experience using the most trusted payment methods in the Eurozone.",
        method: "card",
        geo: "EU",
        currencies: [
            "EUR"
        ],
        tags: [
            "Visa",
            "Mastercard"
        ],
        icon: "card"
    },
    {
        id: "eur-apple-pay",
        transactionType: "pay-in",
        title: "EUR Apple Pay",
        description: "Unlock the full potential of the European market with Apple Pay. Provide your customers with a frictionless, secure, and instant way to pay in Euros using their favorite devices.",
        method: "apm",
        geo: "EU",
        currencies: [
            "EUR"
        ],
        tags: [
            "Apple Pay"
        ],
        icon: "globe"
    },
    {
        id: "eur-google-pay",
        transactionType: "pay-in",
        title: "EUR Google Pay",
        description: "Reach millions of customers across the Eurozone by integrating Google Pay. Offer a fast, simple, and secure checkout experience that allows users to pay in Euros using the cards already stored in their Google accounts.",
        method: "apm",
        geo: "EU",
        currencies: [
            "EUR"
        ],
        tags: [
            "Google Pay"
        ],
        icon: "globe"
    },
    {
        id: "eur-open-banking",
        transactionType: "pay-in",
        title: "EUR Open Banking",
        description: "Leverage the power of PSD2 with our Open Banking integration. Enable your customers to pay directly from their bank accounts across the UK and EU, combining the cost-efficiency of bank transfers with the speed of digital commerce.",
        method: "card",
        geo: "EU",
        currencies: [
            "EUR"
        ],
        tags: [
            "Open Banking"
        ],
        icon: "card"
    },
    {
        id: "rub-pay-out-card",
        transactionType: "pay-out",
        title: "RUB Pay-out to card",
        description: "Optimize your business operations with our automated payout solution for the Russian market. Send funds to debit and credit cards issued by any Russian bank (Visa, Mastercard, MIR) with maximum speed and reliability.",
        method: "card",
        geo: "RUS",
        currencies: [
            "RUB"
        ],
        tags: [],
        icon: "card"
    },
    {
        id: "usd-e-com",
        transactionType: "pay-in",
        title: "USD e-com",
        description: "Expand your reach worldwide with our comprehensive USD acquiring solution. Give your customers a smooth checkout with the most trusted card payment methods on a global scale.",
        method: "card",
        geo: "WW",
        currencies: [
            "USD"
        ],
        tags: [
            "Visa",
            "Mastercard"
        ],
        icon: "card"
    },
    {
        id: "usd-google-pay",
        transactionType: "pay-in",
        title: "USD Google Pay",
        description: "Reach customers globally with Google Pay: a fast, simple, and secure checkout that lets users pay in US dollars using cards already saved in their Google accounts.",
        method: "apm",
        geo: "WW",
        currencies: [
            "USD"
        ],
        tags: [
            "Google Pay"
        ],
        icon: "globe"
    },
    {
        id: "usd-apple-pay",
        transactionType: "pay-in",
        title: "USD Apple Pay",
        description: "Offer Apple Pay for US dollar payments: a frictionless, secure experience on iPhone, Apple Watch, and compatible devices for customers around the world.",
        method: "apm",
        geo: "WW",
        currencies: [
            "USD"
        ],
        tags: [
            "Apple Pay"
        ],
        icon: "globe"
    }, 
];

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./src/components/landingV4/IntegrationsScenariosBlock/IntegrationsScenariosBlock.module.scss
var IntegrationsScenariosBlock_module = __webpack_require__(17600);
var IntegrationsScenariosBlock_module_default = /*#__PURE__*/__webpack_require__.n(IntegrationsScenariosBlock_module);
;// CONCATENATED MODULE: ./src/components/landingV4/IntegrationsScenariosBlock/IntegrationsFilterSelect.tsx
"use client";




var IntegrationsFilterSelect = function(props) {
    var ref;
    var fieldId = props.fieldId, label = props.label, value = props.value, placeholderLabel = props.placeholderLabel, options = props.options, onChange = props.onChange;
    var ref1 = (0,react.useState)(false), open = ref1[0], setOpen = ref1[1];
    var rootRef = (0,react.useRef)(null);
    var triggerId = "".concat(fieldId, "-trigger");
    var listboxId = "".concat(fieldId, "-listbox");
    var items = (0,react.useMemo)(function() {
        return [
            {
                value: "",
                label: placeholderLabel
            }
        ].concat((0,_to_consumable_array/* default */.Z)(options));
    }, [
        placeholderLabel,
        options
    ]);
    var ref2;
    var displayLabel = value === "" ? placeholderLabel : (ref2 = (ref = items.find(function(o) {
        return o.value === value;
    })) === null || ref === void 0 ? void 0 : ref.label) !== null && ref2 !== void 0 ? ref2 : placeholderLabel;
    (0,react.useEffect)(function() {
        if (!open) {
            return;
        }
        var closeIfOutside = function(e) {
            var ref;
            if (!((ref = rootRef.current) === null || ref === void 0 ? void 0 : ref.contains(e.target))) {
                setOpen(false);
            }
        };
        var onKey = function(e) {
            if (e.key === "Escape") {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", closeIfOutside);
        document.addEventListener("touchstart", closeIfOutside);
        document.addEventListener("keydown", onKey);
        return function() {
            document.removeEventListener("mousedown", closeIfOutside);
            document.removeEventListener("touchstart", closeIfOutside);
            document.removeEventListener("keydown", onKey);
        };
    }, [
        open
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (IntegrationsScenariosBlock_module_default()).field,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                className: (IntegrationsScenariosBlock_module_default()).fieldLabel,
                id: "".concat(fieldId, "-label"),
                htmlFor: triggerId,
                children: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                ref: rootRef,
                className: (IntegrationsScenariosBlock_module_default()).dropdownRoot,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        id: triggerId,
                        type: "button",
                        className: (IntegrationsScenariosBlock_module_default()).dropdownTrigger,
                        "aria-labelledby": "".concat(fieldId, "-label"),
                        "aria-haspopup": "listbox",
                        "aria-expanded": open,
                        "aria-controls": listboxId,
                        onClick: function() {
                            return setOpen(function(v) {
                                return !v;
                            });
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (IntegrationsScenariosBlock_module_default()).dropdownTriggerLabel,
                            children: displayLabel
                        })
                    }),
                    open && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        id: listboxId,
                        className: (IntegrationsScenariosBlock_module_default()).dropdownList,
                        role: "listbox",
                        "aria-labelledby": "".concat(fieldId, "-label"),
                        children: items.map(function(item) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                className: (IntegrationsScenariosBlock_module_default()).dropdownListItem,
                                role: "presentation",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    type: "button",
                                    className: (IntegrationsScenariosBlock_module_default()).dropdownOption,
                                    role: "option",
                                    "aria-selected": value === item.value,
                                    onClick: function() {
                                        onChange(item.value);
                                        setOpen(false);
                                    },
                                    children: item.label
                                })
                            }, item.value === "" ? "__empty" : item.value);
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/landingV4/IntegrationsScenariosBlock/IntegrationsScenariosIcons.tsx

var FilterFunnelIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3.33337 5H16.6667",
                stroke: "currentColor",
                strokeWidth: "1.66667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.83337 10H14.1667",
                stroke: "currentColor",
                strokeWidth: "1.66667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.33337 15H11.6667",
                stroke: "currentColor",
                strokeWidth: "1.66667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};
var ResultsGridIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: 22,
        height: 22,
        viewBox: "0 0 22 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.16671 4.58337H4.58337V9.16671H9.16671V4.58337Z",
                stroke: "currentColor",
                strokeWidth: "1.375",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.4167 4.58337H12.8334V9.16671H17.4167V4.58337Z",
                stroke: "currentColor",
                strokeWidth: "1.375",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.16671 12.8334H4.58337V17.4167H9.16671V12.8334Z",
                stroke: "currentColor",
                strokeWidth: "1.375",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.4167 12.8334H12.8334V17.4167H17.4167V12.8334Z",
                stroke: "currentColor",
                strokeWidth: "1.375",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/landingV4/IntegrationsScenariosBlock/IntegrationScenarioCardIcon.tsx

/** Compact card icon for integration scenario tiles (outline). */ var IntegrationScenarioCardIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: 22,
        height: 17,
        viewBox: "0 0 22 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1.375 4.25C1.375 2.76609 2.57959 1.5625 4.0625 1.5625H17.9375C19.4204 1.5625 20.625 2.76609 20.625 4.25V12.75C20.625 14.2339 19.4204 15.4375 17.9375 15.4375H4.0625C2.57959 15.4375 1.375 14.2339 1.375 12.75V4.25Z",
                stroke: "currentColor",
                strokeWidth: "1.375",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1.375 6.60938H20.625",
                stroke: "currentColor",
                strokeWidth: "1.375",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.84375 11.7812H8.9375",
                stroke: "currentColor",
                strokeWidth: "1.375",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/landingV4/IntegrationsScenariosBlock/ScenarioCard.tsx






var ScenarioCard = function(props) {
    var scenario = props.scenario;
    var transactionLabel = TRANSACTION_LABELS[scenario.transactionType];
    var paymentTags = getPaymentSystemTags(scenario);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
        className: (IntegrationsScenariosBlock_module_default()).card,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (IntegrationsScenariosBlock_module_default()).cardTop,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (IntegrationsScenariosBlock_module_default()).typeBadges,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (IntegrationsScenariosBlock_module_default()).typeBadge,
                            children: transactionLabel
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (IntegrationsScenariosBlock_module_default()).cardIconWrap,
                        "aria-hidden": true,
                        children: scenario.icon === "globe" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(IntegrationsHeroIcons/* IntegrationsHeroGlobeIcon */.KU, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(IntegrationScenarioCardIcon, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                type: "h3",
                color: "white",
                className: (IntegrationsScenariosBlock_module_default()).cardTitle,
                children: scenario.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (IntegrationsScenariosBlock_module_default()).descriptionGrow,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                    type: "regular14",
                    color: "white50",
                    whiteSpace: "normal",
                    className: (IntegrationsScenariosBlock_module_default()).cardDescription,
                    children: scenario.description
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("dl", {
                className: (IntegrationsScenariosBlock_module_default()).details,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (IntegrationsScenariosBlock_module_default()).detailRow,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                    type: "regular14",
                                    className: (IntegrationsScenariosBlock_module_default()).detailLabel,
                                    children: "Method"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                className: (IntegrationsScenariosBlock_module_default()).detailDd,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                    type: "regular14",
                                    color: "white",
                                    children: formatMethod(scenario.method)
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (IntegrationsScenariosBlock_module_default()).detailRow,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                    type: "regular14",
                                    className: (IntegrationsScenariosBlock_module_default()).detailLabel,
                                    children: "GEO"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                className: (IntegrationsScenariosBlock_module_default()).detailDd,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                    type: "regular14",
                                    color: "white",
                                    children: scenario.geo
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (IntegrationsScenariosBlock_module_default()).detailRow,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                    type: "regular14",
                                    className: (IntegrationsScenariosBlock_module_default()).detailLabel,
                                    children: "Currency"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                className: (IntegrationsScenariosBlock_module_default()).detailDd,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (IntegrationsScenariosBlock_module_default()).currencyPills,
                                    children: scenario.currencies.map(function(c) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: (IntegrationsScenariosBlock_module_default()).currencyPill,
                                            children: c
                                        }, c);
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (IntegrationsScenariosBlock_module_default()).tagRow,
                children: paymentTags.map(function(tag) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (IntegrationsScenariosBlock_module_default()).tag,
                        children: tag
                    }, tag);
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/landingV4/IntegrationsScenariosBlock/IntegrationsScenariosBlock.tsx
"use client";










var IntegrationsScenariosBlock = function() {
    var regions = (0,react.useMemo)(function() {
        return Array.from(new Set(INTEGRATION_SCENARIOS.map(function(s) {
            return s.geo;
        }))).sort(function(a, b) {
            return a.localeCompare(b);
        });
    }, []);
    var currencies = (0,react.useMemo)(function() {
        return Array.from(new Set(INTEGRATION_SCENARIOS.flatMap(function(s) {
            return s.currencies;
        }))).sort(function(a, b) {
            return a.localeCompare(b);
        });
    }, []);
    var paymentTags = (0,react.useMemo)(function() {
        return Array.from(new Set(INTEGRATION_SCENARIOS.flatMap(function(s) {
            return getPaymentSystemTags(s);
        }))).sort(function(a, b) {
            return a.localeCompare(b);
        });
    }, []);
    var ref = (0,react.useState)(FILTER_EMPTY), transactionType = ref[0], setTransactionType = ref[1];
    var ref1 = (0,react.useState)(FILTER_EMPTY), region = ref1[0], setRegion = ref1[1];
    var ref2 = (0,react.useState)(FILTER_EMPTY), currency = ref2[0], setCurrency = ref2[1];
    var ref3 = (0,react.useState)(FILTER_EMPTY), method = ref3[0], setMethod = ref3[1];
    var ref4 = (0,react.useState)(FILTER_EMPTY), paymentSystem = ref4[0], setPaymentSystem = ref4[1];
    var filtered = (0,react.useMemo)(function() {
        return INTEGRATION_SCENARIOS.filter(function(s) {
            if (transactionType && s.transactionType !== transactionType) {
                return false;
            }
            if (region && s.geo !== region) {
                return false;
            }
            if (currency && !s.currencies.includes(currency)) {
                return false;
            }
            if (method && s.method !== method) {
                return false;
            }
            if (paymentSystem && !getPaymentSystemTags(s).includes(paymentSystem)) {
                return false;
            }
            return true;
        });
    }, [
        transactionType,
        region,
        currency,
        method,
        paymentSystem
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
        className: (IntegrationsScenariosBlock_module_default()).root,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (IntegrationsScenariosBlock_module_default()).filterPanel,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (IntegrationsScenariosBlock_module_default()).filterTitleRow,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (IntegrationsScenariosBlock_module_default()).filterTitleIcon,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterFunnelIcon, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                type: "medium18",
                                color: "white",
                                children: "Filter Integrations"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (IntegrationsScenariosBlock_module_default()).filterGrid,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IntegrationsFilterSelect, {
                                fieldId: "integrations-filter-transaction-type",
                                label: "Transaction Type",
                                value: transactionType,
                                placeholderLabel: FILTER_NOT_SELECTED_LABEL,
                                options: [
                                    {
                                        value: "pay-in",
                                        label: "Pay-in"
                                    },
                                    {
                                        value: "pay-out",
                                        label: "Pay-out"
                                    }, 
                                ],
                                onChange: setTransactionType
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IntegrationsFilterSelect, {
                                fieldId: "integrations-filter-region",
                                label: "Region (GEO)",
                                value: region,
                                placeholderLabel: FILTER_NOT_SELECTED_LABEL,
                                options: regions.map(function(r) {
                                    return {
                                        value: r,
                                        label: r
                                    };
                                }),
                                onChange: setRegion
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IntegrationsFilterSelect, {
                                fieldId: "integrations-filter-currency",
                                label: "Currency",
                                value: currency,
                                placeholderLabel: FILTER_NOT_SELECTED_LABEL,
                                options: currencies.map(function(c) {
                                    return {
                                        value: c,
                                        label: c
                                    };
                                }),
                                onChange: setCurrency
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IntegrationsFilterSelect, {
                                fieldId: "integrations-filter-method",
                                label: "Payment Method",
                                value: method,
                                placeholderLabel: FILTER_NOT_SELECTED_LABEL,
                                options: [
                                    {
                                        value: "card",
                                        label: "Card"
                                    },
                                    {
                                        value: "apm",
                                        label: "APM"
                                    }, 
                                ],
                                onChange: setMethod
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IntegrationsFilterSelect, {
                                fieldId: "integrations-filter-payment-system",
                                label: "Payment System",
                                value: paymentSystem,
                                placeholderLabel: FILTER_NOT_SELECTED_LABEL,
                                options: paymentTags.map(function(tag) {
                                    return {
                                        value: tag,
                                        label: tag
                                    };
                                }),
                                onChange: setPaymentSystem
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (IntegrationsScenariosBlock_module_default()).resultsHeader,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (IntegrationsScenariosBlock_module_default()).resultsTitleRow,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (IntegrationsScenariosBlock_module_default()).resultsGridIcon,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResultsGridIcon, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: (IntegrationsScenariosBlock_module_default()).resultsTitle,
                            children: "Integration Scenarios"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: (IntegrationsScenariosBlock_module_default()).resultsBadge,
                            children: [
                                filtered.length,
                                " results"
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (IntegrationsScenariosBlock_module_default()).cardsGrid,
                children: filtered.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                    type: "regular16",
                    color: "white50",
                    whiteSpace: "normal",
                    className: (IntegrationsScenariosBlock_module_default()).emptyState,
                    children: "No integrations match these filters. Try adjusting your selections."
                }) : filtered.map(function(scenario) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ScenarioCard, {
                        scenario: scenario
                    }, scenario.id);
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/landingV4/IntegrationsScenariosBlock/index.ts


// EXTERNAL MODULE: ./src/components/landingV4/SnackbarProvider/index.ts + 4 modules
var SnackbarProvider = __webpack_require__(7513);
// EXTERNAL MODULE: ./src/components/layout/MainLayout/EmptyLayout.tsx
var EmptyLayout = __webpack_require__(46615);
;// CONCATENATED MODULE: ./src/pages/integrations.tsx













var Page = function() {
    (0,react.useLayoutEffect)(function() {
        document.documentElement.classList.add("v4");
        document.documentElement.style.setProperty("--background", "#09090B");
        return function() {
            document.documentElement.classList.remove("v4");
            document.documentElement.style.removeProperty("--background");
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SnackbarProvider/* SnackbarProvider */.w, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "Integrations | SmartGates"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "Ready-to-use payment integrations: 100+ scenarios, PCI DSS compliant infrastructure, and fast setup for global pay-ins and mass pay-outs."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* Header */.h, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IntegrationsHero, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IntegrationsScenariosBlock, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IntegrationsMethodSpecsBlock, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IntegrationsMatchCtaBlock/* IntegrationsMatchCtaBlock */.H, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FAQBlock/* FAQBlock */.C, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeedbackBlock/* FeedbackBlock */.O, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* Footer */.$, {})
        ]
    });
};
Page.getLayout = function(page) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyLayout/* EmptyLayout */.T, {
        withFloatMenu: false,
        children: page
    });
};
var __N_SSG = true;
/* harmony default export */ var integrations = (Page);


/***/ }),

/***/ 39095:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"IntegrationsHero_root__RI5Te","inner":"IntegrationsHero_inner__ZejqT","sectionEyebrow":"IntegrationsHero_sectionEyebrow__j_OWD","sectionLabel":"IntegrationsHero_sectionLabel__oXXCL","sectionLabelLine":"IntegrationsHero_sectionLabelLine__hiYVX","title":"IntegrationsHero_title__hBj_7","description":"IntegrationsHero_description__MozzB","badges":"IntegrationsHero_badges__eRcJd","badge":"IntegrationsHero_badge__QNFhB","badgeIcon":"IntegrationsHero_badgeIcon__gK_Eq"};

/***/ }),

/***/ 81793:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"IntegrationsMatchCtaBlock_root__N7i_M","banner":"IntegrationsMatchCtaBlock_banner__0jXKx","copy":"IntegrationsMatchCtaBlock_copy__UeZ1w","headline":"IntegrationsMatchCtaBlock_headline__PnMvc","description":"IntegrationsMatchCtaBlock_description__X7r6Y","actions":"IntegrationsMatchCtaBlock_actions__yz1Ha","visual":"IntegrationsMatchCtaBlock_visual__nontv","globeStage":"IntegrationsMatchCtaBlock_globeStage__TpCwU","globeGlow":"IntegrationsMatchCtaBlock_globeGlow___1oSl","globeCircle":"IntegrationsMatchCtaBlock_globeCircle__Lo2Gi","globeIcon":"IntegrationsMatchCtaBlock_globeIcon__q3sbz","globeSubtext":"IntegrationsMatchCtaBlock_globeSubtext__b_MrV","contactLinkPlain":"IntegrationsMatchCtaBlock_contactLinkPlain__jhZ2R","contactSalesButton":"IntegrationsMatchCtaBlock_contactSalesButton__yt01L","docsLinkButton":"IntegrationsMatchCtaBlock_docsLinkButton__mqpbP"};

/***/ }),

/***/ 14633:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"IntegrationsMethodSpecsBlock_root__Uwl06","sectionHead":"IntegrationsMethodSpecsBlock_sectionHead__zwl4H","sectionIcon":"IntegrationsMethodSpecsBlock_sectionIcon__MYU_f","sectionTitle":"IntegrationsMethodSpecsBlock_sectionTitle__ueoTu","cards":"IntegrationsMethodSpecsBlock_cards__7IF1Y","card":"IntegrationsMethodSpecsBlock_card__yMVcs","cardIconWrap":"IntegrationsMethodSpecsBlock_cardIconWrap__z_8ch","cardTitle":"IntegrationsMethodSpecsBlock_cardTitle__1pOKZ","cardDescription":"IntegrationsMethodSpecsBlock_cardDescription__4BQ93"};

/***/ }),

/***/ 17600:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"IntegrationsScenariosBlock_root__lUGN6","filterPanel":"IntegrationsScenariosBlock_filterPanel__KBkv7","filterTitleRow":"IntegrationsScenariosBlock_filterTitleRow__0PU02","filterTitleIcon":"IntegrationsScenariosBlock_filterTitleIcon__FPCR5","filterGrid":"IntegrationsScenariosBlock_filterGrid__QZwzW","field":"IntegrationsScenariosBlock_field__RtARX","fieldLabel":"IntegrationsScenariosBlock_fieldLabel__8FB6F","dropdownRoot":"IntegrationsScenariosBlock_dropdownRoot__PMEBw","dropdownTrigger":"IntegrationsScenariosBlock_dropdownTrigger__0wp_C","dropdownTriggerLabel":"IntegrationsScenariosBlock_dropdownTriggerLabel__7qxc_","dropdownList":"IntegrationsScenariosBlock_dropdownList__Z3wdG","dropdownListItem":"IntegrationsScenariosBlock_dropdownListItem__c0DFn","dropdownOption":"IntegrationsScenariosBlock_dropdownOption__DDzUv","resultsHeader":"IntegrationsScenariosBlock_resultsHeader__9e9ED","resultsTitleRow":"IntegrationsScenariosBlock_resultsTitleRow____q_y","resultsGridIcon":"IntegrationsScenariosBlock_resultsGridIcon__jofbQ","resultsTitle":"IntegrationsScenariosBlock_resultsTitle__UMCQj","resultsBadge":"IntegrationsScenariosBlock_resultsBadge__e43Lg","cardsGrid":"IntegrationsScenariosBlock_cardsGrid__0NW1G","card":"IntegrationsScenariosBlock_card__vbQH5","emptyState":"IntegrationsScenariosBlock_emptyState__bw8ea","cardTop":"IntegrationsScenariosBlock_cardTop___ZoaE","typeBadges":"IntegrationsScenariosBlock_typeBadges__hfabs","typeBadge":"IntegrationsScenariosBlock_typeBadge__5uqzF","cardIconWrap":"IntegrationsScenariosBlock_cardIconWrap__qYUZq","cardTitle":"IntegrationsScenariosBlock_cardTitle__dpJBB","descriptionGrow":"IntegrationsScenariosBlock_descriptionGrow__2_hd8","cardDescription":"IntegrationsScenariosBlock_cardDescription__Nyru_","details":"IntegrationsScenariosBlock_details__ssAcI","detailRow":"IntegrationsScenariosBlock_detailRow__UpdGi","detailDd":"IntegrationsScenariosBlock_detailDd__j5I7m","detailLabel":"IntegrationsScenariosBlock_detailLabel__5gVLy","currencyPills":"IntegrationsScenariosBlock_currencyPills__iHrKB","currencyPill":"IntegrationsScenariosBlock_currencyPill__5y9nv","tagRow":"IntegrationsScenariosBlock_tagRow__dRQCI","tag":"IntegrationsScenariosBlock_tag__h2pWM"};

/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(5443)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [536,522,928,834,168,961,774,888,179], function() { return __webpack_exec__(78348); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);